export default {
        apiKey: "AIzaSyC_0L-m3ii8g6sZZgNqoaulLViCSFncTTQ",
        authDomain: "cinema-quasar.firebaseapp.com",
        databaseURL: "https://cinema-quasar.firebaseio.com",
        projectId: "cinema-quasar",
        storageBucket: "cinema-quasar.appspot.com",
        messagingSenderId: "55222967535",
        appId: "1:55222967535:web:675ffd767989acfa"
}